/**
 * Outbound screened-dialer contracts (ADR 0023). Shared by web + api.
 *
 * These calls are placed from the TwilioPulse platform account, screened by the
 * platform Twilio Functions (human / voicemail / screener), and tracked per-call
 * in the `DialerCall` ledger. Distinct from the telemetry `Call` type, which is
 * ingested from a tenant's own account.
 */
export const DIALER_CALL_STATUSES = [
    "queued",
    "placing",
    "initiated",
    "ringing",
    "in_progress",
    "classifying",
    "classified",
    "handing_off",
    "voicemail",
    "completed",
    "failed",
    "no_answer",
    "canceled",
];
export const DIALER_CALL_BRANCHES = [
    "human",
    "voicemail",
    "screener",
    "interrupted",
    "fallback",
    "unsure",
];
const ALL_FIELDS = ["voicemailMsg", "screenerMsg", "handoffMsg"];
export const DIALER_VARIABLES = [
    {
        key: "businessName",
        label: "Business name",
        description: "Your business's display name (AgentFlow → Settings → Branding, else the tenant name).",
        sampleValue: "Acme HVAC",
        fields: ALL_FIELDS,
    },
    {
        key: "CALLBACK",
        label: "Callback number",
        description: "The number you're dialing from, read digit by digit. Voicemail & screener only.",
        sampleValue: "4 1 5 5 5 5 0 1 2 3",
        fields: ["voicemailMsg", "screenerMsg"],
    },
];
/** Variables insertable into a given message field. */
export function dialerVariablesFor(field) {
    return DIALER_VARIABLES.filter((v) => v.fields.includes(field));
}
/** Preview-time substitution. Unknown `{tokens}` are left literal. */
export function interpolateDialerMessage(template, values) {
    return template.replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (match, key) => typeof values[key] === "string" ? values[key] : match);
}
//# sourceMappingURL=dialer.js.map